import { Button } from '@enterprise-ui/canvas-ui-react'
import React from 'react'
import { SET_FIELD } from './Constants'
import { useGlobalForm } from '../Context/GlobalFormStateContext'
import axios from 'axios'
import { useEnv } from '@praxis/component-runtime-env'
import { EnvConfig } from '../../../config/appConfig'
import { useAuth } from '@praxis/component-auth'
import { EnterpriseIcon, ImageIcon } from '@enterprise-ui/icons'

interface MainProp {
  value: any
  rowIndex: any
  node: any
}

const ViewAttachment: React.FC<MainProp> = (props) => {
  const auth = useAuth()
  const env = useEnv() as EnvConfig
  const [state, dispatch] = useGlobalForm()

  const viewAttachments = async (attachmentId: string, filename: string) => {
    return await axios
      .get(`${env.attachments.attachmentServiceUrl}files/${attachmentId}`, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-api-key': `${env?.apiKey}`,
          Authorization: `Bearer ${auth?.session?.accessToken}`,
        },
      })
      .then((res: any) => {
        if (res.status === 200) {
          dispatch({
            type: SET_FIELD,
            payload: [{ id: 'setAttachmentView', value: true }],
          })
          let blob
          let fileType = filename.slice(
            filename.lastIndexOf('.') + 1,
            filename.length,
          )
          if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
            blob = new Blob([res.data], { type: 'image/png' })
            dispatch({
              type: SET_FIELD,
              payload: [
                { id: 'isAttachmentNotViewable', value: false },
                { id: 'mediaType', value: '' },
                { id: 'fileName', value: filename },
                { id: 'fileUrl', value: window.URL.createObjectURL(blob) },
                {
                  id: 'format',
                  value: ['pdf', 'jpg', 'jpeg', 'png'].includes(fileType),
                },
              ],
            })
          } else if (fileType === 'pdf') {
            blob = new Blob([res.data], { type: 'application/pdf' })
            dispatch({
              type: SET_FIELD,
              payload: [
                { id: 'isAttachmentNotViewable', value: false },
                { id: 'mediaType', value: 'PDF' },
                { id: 'fileName', value: filename },
                { id: 'fileUrl', value: window.URL.createObjectURL(blob) },
                {
                  id: 'format',
                  value: ['pdf', 'jpg', 'jpeg', 'png'].includes(fileType),
                },
              ],
            })
          } else {
            dispatch({
              type: SET_FIELD,
              payload: [
                { id: 'isAttachmentNotViewable', value: true },
                { id: 'mediaType', value: '' },
                { id: 'fileName', value: '' },
                { id: 'fileUrl', value: '' },
                {
                  id: 'format',
                  value: false,
                },
              ],
            })
          }
        }
      })
      .catch((reason: any) => {
        dispatch({
          type: SET_FIELD,
          payload: [
            { id: 'viewAttachment', value: undefined },
            { id: 'attachmentsError', value: true },
            { id: 'toastHeading', value: 'Error Viewing the File' },
            {
              id: 'toastMessage',
              value: 'There was an error viewing the file. Please try again.',
            },
          ],
        })
      })
  }

  const handleAttachmentView = async () => {
    await dispatch({
      type: SET_FIELD,
      payload: [{ id: 'viewAttachment', value: props.node.rowIndex }],
    })
    let allFiles = state.savedAttachments ? state.savedAttachments : []
    let attachment = allFiles[props.node.rowIndex]
    await viewAttachments(
      attachment['attachmentId'],
      attachment['fileName'],
    ).then(async () => {
      await dispatch({
        type: SET_FIELD,
        payload: [
          { id: 'viewAttachment', value: undefined },
          { id: 'fileRowIndex', value: props.node.rowIndex },
        ],
      })
    })
  }

  return (
    <Button
      xs
      onClick={() => {
        handleAttachmentView()
      }}
      isLoading={state.viewAttachment === props.node.rowIndex}
    >
      <EnterpriseIcon icon={ImageIcon} />
    </Button>
  )
}

export default ViewAttachment
